import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import Media from 'components/common/Media'
import Mixin from 'components/common/Mixin'
import SelectOrApplyButton from '../SelectOrApplyButton'
import HTMLContainer from 'components/common/HTMLContainer/HTMLContainer'

const BOTCareersPageBanner = ({
  desktopBackgroundImgURL,
  mobileBackgroundImgURL,
  content,
  ...props
}) =>
  <Wrapper desktopBackgroundImgURL={ desktopBackgroundImgURL } mobileBackgroundImgURL={ mobileBackgroundImgURL }>
    <GenericHTMLContainer>
      <HTMLContainer content={ content } />
      <SelectOrApplyButton { ...props } />
    </GenericHTMLContainer>
  </Wrapper>

BOTCareersPageBanner.propTypes = {
  content: PropTypes.string,
  desktopBackgroundImgURL: PropTypes.string,
  mobileBackgroundImgURL: PropTypes.string
}

export default BOTCareersPageBanner

const Wrapper = styled.div`
  ${props => props.desktopBackgroundImgURL && props.mobileBackgroundImgURL && css`
    ${Mixin.responsive('background-image', `url(${props.desktopBackgroundImgURL})`, `url(${props.mobileBackgroundImgURL})`)}
    background-size: cover;
    background-repeat: no-repeat;
  `}
  display: flex;
  height: 450px;
  ${Media.desktop`
    flex-direction: row;
    justify-content: flex-start;
  `}
  ${Media.mobile`
    flex-direction: column;
    justify-content: flex-end;
  `}
`

const GenericHTMLContainer = styled.div`
  ${Media.desktop`
    padding: 40px 55px;
    width: 500px;
  `}
  ${Media.mobile`
    text-align: center;
    padding: 30px;
  `}
`
